import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import { Navbar, Footer } from './components/layout';
import { Hero, Features, DreamBig, Plans, AboutUs } from './components/sections';
import { TermsOfUse, PrivacyPolicy } from './components/pages';

function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <DreamBig />
      <Plans />
      <AboutUs />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
